import React from 'react'
// import NavLinkMenu from '../../../../components/navlink/NavLinkMenu';
import AppTabMenu from '../../../../component/layout/AppTabMenu.tsx'
import { centersMenu } from '../../../../utils/constants/navlinks-Menu'

const CenterTypeLinks = ({ blur = false }) => {
  return <AppTabMenu options={centersMenu} blur={blur} />
}

export default CenterTypeLinks
